const kebabCase = (value) => value.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();

export { kebabCase };
//# sourceMappingURL=kebabCase.js.map
